import MainDataProvider from "../../../core/providers/main-data.provider";
export default class DataProvider extends MainDataProvider {
    constructor(options) {
        super(options);
    }
    get options() {
        return super.options;
    }
}
